import { schemes, zSchema } from "@zeal/common";

export const updateCompanyInfoRequestSchema = zSchema.object({
  companyID: schemes.uuid(),
  business_name: zSchema.string().optional(),
  business_description: zSchema.string().optional(),
  legalStructure: zSchema.string().optional(),
  business_ein: zSchema.string().optional(),
  business_phone: zSchema.string().optional(),
  business_address: zSchema.string().optional(),
  business_city: zSchema.string().optional(),
  business_state: zSchema.string().optional(),
  business_zip: zSchema.string().optional(),
  isMailingAddressDifferent: zSchema.boolean().optional(),
  mail_address: zSchema.string().optional(),
  mail_city: zSchema.string().optional(),
  mail_state: zSchema.string().optional(),
  mail_zip: zSchema.string().optional(),
  isPhysicalAddressSameAsBusiness: zSchema.boolean().optional(),
  physical_address: zSchema.string().optional(),
  physical_city: zSchema.string().optional(),
  physical_state: zSchema.string().optional(),
  physical_zip: zSchema.string().optional(),
  email: zSchema.string().optional(),
  first_name: zSchema.string().optional(),
  last_name: zSchema.string().optional(),
  job_title: zSchema.string().optional(),
  ownershipPercentage: zSchema.number().optional(),
  ssn: zSchema.string().optional(),
  dob: zSchema.string().optional(),
  address: zSchema.string().optional(),
  address_line2: zSchema.string().optional(),
  city: zSchema.string().optional(),
  state: zSchema.string().optional(),
  zip: zSchema.string().optional(),
});

export type TUpdateCompanyInfoRequest = zSchema.infer<
  typeof updateCompanyInfoRequestSchema
>;

export type TUpdateCompanyInfoResponse = zSchema.infer<
  typeof updateCompanyInfoRequestSchema
>;
